module.exports = __webpack_public_path__ + "img/icon_map_38_on_011.0a364048.png";